module.exports = __webpack_public_path__ + "img/5_init.d9e0a8cf.png";